var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShieldCheck({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "a/icons/micro/16/saml-certificates") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a/icons/micro/16/saml-certificates",
    stroke: "none",
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(2, 0.5)",
    stroke: "color(display-p3 0.000 0.000 0.000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12,8.24895561 C12,11.9983277 9.375,13.8730137 6.255,14.9603316 C6.09162186,15.0156854 5.9141531,15.0130371 5.7525,14.9528328 C2.625,13.8730137 0,11.9983277 0,8.24895561 L0,2.99983475 C0,2.58569054 0.335786438,2.24996034 0.75,2.24996034 C2.25,2.24996034 4.125,1.35011104 5.43,0.210301942 C5.7582553,-0.0701006473 6.2417447,-0.0701006473 6.57,0.210301942 C7.8825,1.35760979 9.75,2.24996034 11.25,2.24996034 C11.6642136,2.24996034 12,2.58569054 12,2.99983475 L12,8.24895561 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    points: "4 7.5 5.33333333 9 8 6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShieldCheck);
export default __webpack_public_path__ + "static/media/shield-check.49921a850de1fa8bafbc8a563814c0b0.svg";
export { ForwardRef as ReactComponent };